import { motion } from 'motion/react';
import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

export type CheckIconProps = ComponentProps<typeof motion.svg> &
  ComponentProps<'svg'>;

export function CheckIcon({ className, ...props }: CheckIconProps) {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={twMerge('text-zmyle-primary h-4 w-4', className)}
      {...props}
    >
      <motion.path
        d="M5 12l5 5L19 7"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 0.1, ease: 'easeInOut' }}
      />
    </motion.svg>
  );
}
